import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from "rxjs/index";
import { ListInvoiceResponse } from "./list-invoice-response";
import { CommonDataService } from "../common/common-data.service";
import { OneOffPaymentResponse } from "./one-off-payment-response";
import {LinkedAccountBalanceResponse} from "../common/linked-account-balance-response";


@Injectable()
export class InvoiceService {
  constructor(private httpClient: HttpClient, private commonDataService: CommonDataService){};

  getInvoiceListForCustomer(pageNumber: any, pageSize: any): Observable<ListInvoiceResponse> {
    const params = new HttpParams()
      .append('pageNumber', pageNumber)
      .append('pageSize', pageSize)
    return this.httpClient.get<ListInvoiceResponse>(
      `/api/getInvoiceListForCustomer/${this.commonDataService.user.billingAccountId}`,
      { params: params }
      );
  }

  getDownloadPdfUrl(invoiceId: any, billingAccountId: string): Observable<any> {
    const httpOptions = {
      'responseType'  : 'arraybuffer' as 'json'
      //'responseType'  : 'blob' as 'json'        //This also worked
    };
    return this.httpClient.get<any>(`/api/getDownloadPdfUrl/${billingAccountId}/${invoiceId}`, httpOptions);
  }

  getAccountBalance(billingAccountId: string): Observable<string>{
    return this.httpClient.get('/api/getAccountBalance/' + billingAccountId, {responseType:'text'})
  }

  getLinkedAccountBalance(billingAccountId: string): Observable<LinkedAccountBalanceResponse> {
    return this.httpClient.get<LinkedAccountBalanceResponse>(`/api/linkedAccountBalance/${billingAccountId}`);
  }

  payOutstandingBalance(): Observable<OneOffPaymentResponse> {
    return this.httpClient.post<OneOffPaymentResponse>(`/api/paymentOneOff/${this.commonDataService.user.billingAccountId}`, null);
  }

}
